import { Table } from '@rd-web-markets/shared/dist/util';
import React from 'react';
import { useTranslation } from 'react-i18next';
export default function ProjectVersionChanges(_ref) {
  let {
    version,
    isExpanded,
    toggleExpanded
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!version.object_changes || Object.keys(version.object_changes).length === 0) {
    return null;
  }
  const changeKeys = Object.keys(version.object_changes).filter(k => k !== 'updated_at');
  if (changeKeys.length === 0) {
    return null;
  }
  const translateValue = value => {
    if (value === undefined) return 'undefined';
    if (value === null) return 'NULL';
    const str = value.toString();
    const translated = t(str, {
      defaultValue: ''
    });
    return translated || str;
  };
  const headers = [{
    text: t('change_header_field')
  }, {
    text: t('change_header_old')
  }, {
    text: t('change_header_new')
  }];
  const rows = changeKeys.map((changeKey, index) => ({
    key: index,
    columns: [t(changeKey), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: translateValue(version.object_changes[changeKey][0])
      }
    }), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: translateValue(version.object_changes[changeKey][1])
      }
    })]
  }));
  if (changeKeys.length === 1) {
    return /*#__PURE__*/React.createElement(Table, {
      headers: headers,
      rows: rows,
      showControls: false
    });
  }
  const displayRows = isExpanded ? rows : rows.slice(0, 1);
  const hasMoreRows = rows.length > 1;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Table, {
    opts: {
      className: 'ProjectVersionChanges-table'
    },
    headers: headers,
    rows: displayRows,
    showControls: false
  }), hasMoreRows && /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: 'pointer',
      textAlign: 'center',
      padding: '8px',
      color: '#007bff',
      fontSize: '14px'
    },
    onClick: () => toggleExpanded(version.id)
  }, isExpanded ? '▼ Collapse' : `▶ Expand (${rows.length - 1} more)`));
}